import X from "../assets/coms/xlogo.png";
import Discord from "../assets/coms/discord.png";
import Instagram from "../assets/coms/instagram.png";
import Medium from "../assets/coms/medium.png";
import Telegram from "../assets/coms/telegram.png";
import Youtube from "../assets/coms/youtube.png";
import { SocialLink } from "../models/coms.model";

export const SOCIAL_LINKS: SocialLink[] = [
    { href: "https://twitter.com/bonk_inu", icon: X, label: "X" },
    { href: "https://discord.com/invite/qaQa6M6mN2", icon: Discord, label: "Discord" },
    { href: "https://www.instagram.com/official_bonk_inu/", icon: Instagram, label: "Instagram" },
    { href: "https://medium.com/@bonk_inu", icon: Medium, label: "Medium" },
    { href: "https://t.me/Official_Bonk_Inu", icon: Telegram, label: "Telegram" },
    { href: "https://www.youtube.com/@bonk_inu", icon: Youtube, label: "YouTube" },
];
